import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IsRowSelectable, RowNode } from 'ag-grid-community';
import { BtnCellRendererEditDelete } from '../../grid/btn-cell-render-edit-delete';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserServiceService } from 'src/app/service/user-service.service';
import { Constants } from "src/app/constants";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BookingInfoService } from 'src/app/service/export-parts/booking-info.service';
import { formatDate } from '@angular/common';
import * as moment from 'moment';
import { Subject } from "rxjs";

@Component({
  selector: 'app-add-booking-info',
  templateUrl: './add-booking-info.component.html',
  styleUrls: ['./add-booking-info.component.scss']
})
export class AddBookingInfoComponent implements OnInit {
  playAudio: Subject<any> = new Subject();
  submitted = false;
  heading!: string;
  eventType: any;
  successMessage: any
  errorMessage: any;
  fromDate: any;
  serviceProviderList: any = []
  booking:any = []
  regexStr = '^[a-zA-Z0-9]*$';
  maxDate = "9999-12-31";
  constructor(public dialogRef: MatDialogRef<AddBookingInfoComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any,
    private constants: Constants, private ngxUiLoaderService: NgxUiLoaderService,
    private service: BookingInfoService, private fb: FormBuilder) { }

  addForm = this.fb.group({

    waybill: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(14)]],
    // destination: ['', [Validators.required]],
    cutOffDate: ['', [Validators.required]],
    vessel: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(30)]],
    voyage: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(6)]],
    eta: ['', [Validators.required]],
    serviceProvider: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(10)]],
    // container: ['', [Validators.required]],
  })
  ngOnInit(): void {
    this.fromDate = formatDate(new Date(), "yyyy-MM-dd", "en");
    this.heading = this.dataStore.header;
    this.eventType = this.dataStore.eventType
    for(let i=0;i<this.dataStore?.fullData?.length;i++)
    {
      this.booking.push(this.dataStore.fullData[i].waybill);
    }
    
    if (this.eventType == 'Edit') {
      let cutOffDate = moment(this.dataStore.edit.cuttoff_date).format("YYYY-MM-DD");
      let etaDate = moment(this.dataStore.edit.eta).format("YYYY-MM-DD");
      this.addForm.controls.waybill.disable(); 
      /*this.addForm.controls.serviceProvider.disable();
      this.addForm.controls.vessel.disable(); 
      this.addForm.controls.voyage.disable();*/
      this.addForm.controls.cutOffDate.setValue(cutOffDate);
      this.addForm.controls.waybill.setValue(this.dataStore.edit.waybill);
      this.addForm.controls.serviceProvider.setValue(this.dataStore.edit.service_provider);
      this.addForm.controls.vessel.setValue(this.dataStore.edit.vessel);
      this.addForm.controls.voyage.setValue(this.dataStore.edit.voyage);
      this.addForm.controls.eta.setValue(etaDate);
    }

  }
  onClick() {
    this.dialogRef.close({
      event: 'Noevent'
    })
  }
  get f(): { [key: string]: AbstractControl } {
    return this.addForm.controls;
  }
  submitForm() {
    this.submitted = true
    if (this.addForm.invalid) {
      return;
    }
    else {
      this.addorUpdateBookingInfo();
    }
  }

  addorUpdateBookingInfo() {

    let addUserObj = {
      // destination: this.addForm.controls.destination.value,
      waybill: this.addForm.controls.waybill.value?.toUpperCase(),
      cuttoff_date: this.addForm.controls.cutOffDate.value,
      vessel: this.addForm.controls.vessel.value?.toUpperCase(),
      voyage: this.addForm.controls.voyage.value?.toUpperCase(),
      eta: this.addForm.controls.eta.value,
      service_provider: this.addForm.controls.serviceProvider.value,
      // container: this.addForm.controls.container.value
    }
const cutOffValidate = moment(moment().format('YYYY-MM-DD')).diff(moment(addUserObj.cuttoff_date).format('YYYY-MM-DD'));
const etaValidate = moment(moment().format('YYYY-MM-DD')).diff(moment(addUserObj.eta).format('YYYY-MM-DD'));
if(cutOffValidate>0 && etaValidate>0)
{
  this.clearMsg();
  this.errorMessage ='CutOff and ETA Dates should not be in past'
  this.showError(this.errorMessage);
}
else if(cutOffValidate>0)
{
  this.clearMsg();
  this.errorMessage ='CutOff Date should not be in past'//+' CutOff Date : '+addUserObj.cuttoff_date;
  
  this.showError(this.errorMessage)
}else if(etaValidate>0)
{
  this.clearMsg();
  this.errorMessage ='ETA Date should not be in past'//+' ETA Date : '+addUserObj.eta;
  
  this.showError(this.errorMessage)
}else
{
  if(this.booking.includes(addUserObj.waybill))
  {
    this.clearMsg();
   this.errorMessage = "Waybill Number Already Exist";
    this.showError(this.errorMessage);
  }
  else{
     this.ngxUiLoaderService.start()
    if (this.eventType == 'ADD') {

      this.service.addBookingInfo(addUserObj).subscribe({
        next: (res) => {
          this.ngxUiLoaderService.stop()
          try {
            if (res.status == "SUCCESS") {
              // this.successMessage = this.constants.APIDataSaved
              this.dialogRef.close(
                {
                  event: 'SaveEvent',
                  status: res.status,
                  eventData: this.constants.APIDataSaved
                }
              );
            }
            if (res.status == 'FAILURE') {
              // this.errorMessage = this.constants.APIErrorMessage
              this.dialogRef.close(
                {
                  event: 'SaveEvent',
                  status: res.status,
                  eventData: res.message
                }
              );
            }
          }
          catch (error) {
          }

        },
        error: (err: any) => {
          this.clearMsg();
          this.errorMessage = this.constants.APIErrorMessage
          this.ngxUiLoaderService.stop()
        }
      })
    }
  }
    if (this.eventType == 'Edit') {
      this.service.updateBookingInfo(addUserObj).subscribe({
        next: (res) => {
          this.ngxUiLoaderService.stop()
          try {
            if (res.status == "SUCCESS") {
              // this.successMessage = this.constants.APIDataUpdated
              this.dialogRef.close(
                {
                  event: 'UpdateEvent',
                  status: res.status,
                  eventData: this.constants.APIDataSaved
                }
              );
            }
            if (res.status == 'FAILURE') {
              // this.errorMessage = this.constants.APIErrorMessage
              this.dialogRef.close(
                {
                  event: 'UpdateEvent',
                  status: res.status,
                  eventData: res.message
                }
              );
            }
          }
          catch (error) {
          }
        },
        error: (err: any) => {
          this.clearMsg();
          this.errorMessage = this.constants.APIErrorMessage
          this.showError(this.errorMessage);
          this.ngxUiLoaderService.stop()
        }
      })
    }
  }
  }
  showError(msg: string) {
    this.playAudio.next('trouble');
    this.errorMessage = msg;
  }
  clearMsg() {
    this.successMessage = "";
    this.errorMessage = "";
  }
  validateField(event: any) {
    return new RegExp(this.regexStr).test(event.key);
  }
  hasSpecialChars(event: any)
 { 
const specialCharPattern = /^[^\s\w]*$/; 
return !specialCharPattern.test(event);
}
routeVlidate(event: any) {
  return this.valSpecialChars(event.key);
}
valSpecialChars(stringIn: any) {
  let fieldValid = true;
  let splChars = "*|,\":<>[]{}`';()@&$#%./!^_?+-=";
  for (let i = 0; i < stringIn.length; i++) {
    if (splChars.indexOf(stringIn.charAt(i)) != -1) {
      fieldValid = false;
    }
  }
  return fieldValid;
}
valSpecialChars1(stringIn: any) {
  let fieldValid = true;
  let splChars = "*|,\":<>[]{}`';()@&$#%./!^_?+-= ";
  for (let i = 0; i < stringIn.length; i++) {
    if (splChars.indexOf(stringIn.charAt(i)) != -1) {
      fieldValid = false;
    }
  }
  return fieldValid;
}
onPaste(event: ClipboardEvent) {
  let clipboardData: any = event.clipboardData;
  let pastedText = clipboardData.getData("text");
  let test = this.valSpecialChars(pastedText);
  if (!test) {
    event.preventDefault();
  }
}
onPaste1(event: ClipboardEvent) {
  let clipboardData: any = event.clipboardData;
  let pastedText = clipboardData.getData("text");
  let test = this.valSpecialChars1(pastedText);
  if (!test) {
    event.preventDefault();
  }
}
}
